import * as React from 'react';
import { Route } from 'react-router-dom';
import Configuration from './configuration/Configuration';
import Health from './resources/health';

export const PublicRoutes = {
    health: "/health"
}

export default [
    <Route exact path="/configuration" render={() => <Configuration />} />,
    <Route exact path={PublicRoutes.health} render={() => <Health/>} />
];
